import {useMutation} from '@tanstack/react-query';
import {login} from "../queries/fetchAuth";
import { useNavigate } from 'react-router-dom';


export function useLogin() {
    const navigate = useNavigate();
    const {
        data,
        mutate: loginUser,
        isError,
        error,
        isSuccess,
        isPending
    } = useMutation({
        mutationKey: ['login'],
        mutationFn: login,
        retry: false
    });

    if (isSuccess) {
      navigate('/');
    }

    return {
        data,
        loginUser,
        isError,
        isLoading: isPending,
        error,
        isSuccess,
    }
}
